<div class="oi-overlay" (click)="onClose()">
  <div class="oi-drawer" (click)="$event.stopPropagation()">

    <div class="oi-sidebar">

      <!-- HEADER -->
      <div class="oi-sb-header">
        <div>
          <div class="oi-sb-title">Order Instructions</div>
          <div class="oi-sb-sub">Only visible to Autoverse team 🤝</div>
        </div>
        <button mat-icon-button (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- BODY -->
      <div class="oi-sb-body">
        <!-- Garage Discount -->
        <div class="icn-with-txt">💸 Garage Discount %</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label class="lbl">Enter expected discount %</mat-label>
          <input matInput type="text" [(ngModel)]="instructionData.garageDiscount" />
          <mat-hint>👉 Use only if any special discount is discussed</mat-hint>
        </mat-form-field>

        <!-- Delivery Mode -->
        <div class="icn-with-txt">🚚 Preferred Delivery Mode </div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="instructionData.deliveryMode">
            <mat-select-trigger> <span [ngClass]="{   'placeholder-color': !instructionData.deliveryMode   }"  >   {{ instructionData.deliveryMode || 'Select delivery mode' }}  </span>   </mat-select-trigger>
            <mat-option value="" disabled class="disabled-option">     Select delivery mode   </mat-option>
            <mat-option value="Smart Slot">🚛 Smart Slot</mat-option>
            <mat-option value="Instant Delivery">⚡ Instant Delivery</mat-option>
            <!-- <mat-option value="Instant Delivery">⚡ Instant Delivery— ₹149.00</mat-option> -->
            <mat-option value="Pickup from Store">🏪 Pickup from Store</mat-option>
          </mat-select>
          <mat-hint>👉 Final delivery depends on stock & route availability</mat-hint>
        </mat-form-field>

        <!-- Notes -->
        <div class="icn-with-txt">🧾 Additional Notes</div>
        <mat-form-field appearance="outline" class="full-width">
          <!-- <mat-label>🧾 Additional Notes</mat-label> -->
          <textarea 
            matInput 
            rows="4"
            maxlength="250"
            [(ngModel)]="instructionData.notes"
            (ngModelChange)="onNotesChange($event)">
          </textarea>
          <!-- <div>👉 Max 250 characters</div>
          <mat-hint align="end">{{ charCount }}/250</mat-hint> -->
        </mat-form-field>
        <div class="hint-parent">
            <div>👉 Max 250 characters</div>
            <div>{{ charCount }}/250</div>
        </div>

        <!-- INFO BOX -->
        <div class="oi-info-box">
          💡 Your instructions help us process your order faster and avoid mistakes.
        </div>
      </div>
      <!-- FOOTER -->
      <div class="oi-sb-footer">
        <button mat-raised-button class="full-width-blue" (click)="onSave()">
          Save Instructions
        </button>

        <button mat-stroked-button class="full-width-blank" (click)="onSkip()">
          Skip for Now
        </button>
      </div>
    </div>
  </div>
</div>